import { GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { auth } from "../../firebase/client";
import { initNewUser } from "../../lib/init-user-profile";

const googleProvider = new GoogleAuthProvider();

const Login = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const next = searchParams.get("next") ?? "/";
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	const onSuccess = () => navigate(next);

	const handleGoogle = async () => {
		setError(null);
		setLoading(true);
		try {
			const result = await signInWithPopup(auth, googleProvider);
			initNewUser(result.user);
			onSuccess();
		} catch {
			setError("Google sign-in failed — please try again.");
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);
		setLoading(true);
		try {
			await signInWithEmailAndPassword(auth, email, password);
			onSuccess();
		} catch {
			setError("Invalid email or password.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<h2>Sign in</h2>
			<button type="button" onClick={handleGoogle} disabled={loading}>
				Continue with Google
			</button>
			<hr />
			<form onSubmit={handleSubmit}>
				<div>
					<label>
						Email
						<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
					</label>
				</div>
				<div>
					<label>
						Password
						<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
					</label>
				</div>
				{error && <p>{error}</p>}
				<button type="submit" disabled={loading}>{loading ? "Signing in…" : "Sign in"}</button>
			</form>
			<p>No account? <Link to="/register">Register</Link></p>
		</div>
	);
};

export default Login;
